<template>
  <Form />
</template>

<script>
// import CalculatorTemplate from "./CalculatorTemplate.vue";
import Form from "./Form.vue";

export default {
  data: () => ({
    amount: null,
  }),
  components: {
    Form,
    // CalculatorTemplate,
  },
  beforeMount() {
    this.$store.state.amount = this.$route.params.amount || "6000";
    this.$store.state.amount = this.$store.state.amount.slice(0, this.$store.state.amount.length - 3);
  },
};
</script>
